// extracted by mini-css-extract-plugin
export default {"root":"InfoBox_root__cxRBq","desc":"InfoBox_desc__GiA-Y"};